import { PDP_MAIN_META_KEYWORDS } from 'components/PDP/Arrangement/translations/constants';

export const pdpHeadMetaCommonLocale = {
  [PDP_MAIN_META_KEYWORDS]:
    'Sweet Anniversary Celebration®, Fruit baskets, Gift baskets,fruit bouquets, Chocolate covered fruit, Fruit Arrangements, gifts, gourmet gift baskets, fresh fruit, gift idea, fruit flower, floral fruit, delicious fruit, chocolate covered strawberries, fruit delivery',
};
